import { useCallback, useMemo } from 'react';
import { useDiscoverReaderQuery } from '../../../hooks/use-discover-readers-query';
import { sortReaders } from '../../utils/readers';

export type UseTerminalReadersQueryProps = {
  locationId: string | undefined;
  stripeLocationId?: string;
};
export const useTerminalReadersQuery = ({ locationId, stripeLocationId }: UseTerminalReadersQueryProps) => {
  const { data, isLoading, isRefetching, refetch } = useDiscoverReaderQuery({
    locationId,
    stripeLocationId,
  });

  const readers = useMemo(() => sortReaders(data ?? []), [data]);

  const refetchReaders = useCallback(() => {
    refetch();
  }, [refetch]);

  const refetchReadersAsync = useCallback(async () => {
    return (await refetch())?.data || [];
  }, [refetch]);

  return {
    readers,
    isReadersLoading: isLoading || isRefetching,
    refetchReaders,
    refetchReadersAsync,
  };
};

export type UseTerminalReadersQuery = ReturnType<typeof useTerminalReadersQuery>;
